/**
 * AureNovel 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * AureNovel 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/aurenovel/member-bg.webp',
  // 标签模块背景图
  tagsBg: '/images/aurenovel/member-bg.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FFB300',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FFF9E8',
  tagInactiveText: '#FFB300',
  commonTagText: '#FFB300',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #FFB300 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #FFF9E8 0%, #FFFFFF 100%)',
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
